import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IArchiveParams, IExamArchiveParams, IGetArchive, IGetArchives, IGetDownloadHistories, IGetExamArchive, IGetExamArchives } from '../models/archives.model';
import QueryString from 'qs';

const uri = '/mgmt/archives';

export const getArchives = (archiveGbn: string, params: IArchiveParams): AxiosPromise<IGetArchives> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/${archiveGbn}?${qsParams}`);
};

export const getArchive = (archiveGbn: string, archiveCode: number): AxiosPromise<IGetArchive> => {
  return axios.get(`${uri}/${archiveGbn}/${archiveCode}`);
};

export const createArchive = (archiveGbn: string, data: FormData): AxiosPromise => {
  return axios.post(`${uri}/${archiveGbn}`, data);
};

export const updateArchive = (archiveGbn: string, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${archiveGbn}`, data);
};

export const deleteArchive = (archiveGbn: string, archiveCode: number): AxiosPromise => {
  return axios.put(`${uri}/${archiveGbn}/${archiveCode}`);
};

export const getDownloadHistories = (archiveGbn: string, archiveCode: number): AxiosPromise<IGetDownloadHistories> => {
  return axios.get(`${uri}/download-log/${archiveGbn}/${archiveCode}`);
};

export const getExamArchives = (params: IExamArchiveParams): AxiosPromise<IGetExamArchives> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/exam?${qsParams}`);
};

export const getExamArchive = (examCode: number): AxiosPromise<IGetExamArchive> => {
  return axios.get(`${uri}/exam/${examCode}`);
};

export const getExamDownloadHistories = (examCode: number): AxiosPromise<IGetDownloadHistories> => {
  return axios.get(`${uri}/download-log/exam/${examCode}`);
};
